import { getLocale } from '../locales/locales';
import { parseTemplate } from 'url-template';
import qs from 'qs';

export function link(url: string) {
  const locale = getLocale().toString();
  return `/${locale}${url.startsWith('/') ? '' : '/'}${url}`;
}

export function getPathNameWithLocale(pathname: string) {
  return pathname.replace('[locale]', getLocale().toString());
}

export function linkWithAllQueryParams(url: string) {
  if (typeof window !== 'undefined' && window.location.search !== '') {
    const queryParams = new URLSearchParams(window.location.search);

    return `${link(url)}?${queryParams.toString()}`;
  }
  return link(url);
}

export function linkWithQueryParams(url: string, filteredQueryParams: string[]) {
  if (typeof window !== 'undefined') {
    const queryParams = new URLSearchParams(window.location.search);

    const selectedQueryParams = new URLSearchParams();

    queryParams.forEach((value, key) => {
      if (filteredQueryParams.includes(key)) {
        selectedQueryParams.set(key, value);
      }
    });

    return selectedQueryParams.toString() !== '' ? `${link(url)}?${selectedQueryParams.toString()}` : link(url);
  }
  return link(url);
}

export const createCacheKey = (
  path: string,
  options?: {
    pathParams?: Record<string, string | number | boolean>;
    params?: Record<string, string | string[] | undefined | number | number[] | boolean>;
  }
) => {
  let result = path;

  if (options?.pathParams) {
    result = parseTemplate(path).expand(options?.pathParams);
  }

  if (options?.params && Object.keys(options?.params).length > 0) {
    result += `?${buildQueryParams(options.params)}`;
  }
  return result;
};

export const buildQueryParams = (params: Record<string, string | string[] | undefined | number | number[] | boolean>) =>
  qs.stringify(params, { arrayFormat: 'comma' });

export const reRouteWithSearchParams = (path: string, searchParams?: string) => {
  const origin = window.location.origin;
  const newUrl = new URL(`${origin}${path}`);
  const _searchParams = searchParams && new URLSearchParams(searchParams);
  window.location.replace(`${newUrl}` + (_searchParams ? `?${_searchParams.toString()}` : ''));
};

export const isExternalUrl = (url: string): boolean | void => {
  if (typeof window !== 'undefined') {
    return new URL(url).hostname !== window.location.hostname;
  }
};
